/* eslint-disable max-len */

import TableList from '@/inheritance/table-list';

export default {
  /**
   * Nombre del componente
   */
  name: 'AccountsList',

  /**
   * Extendemos la funcionalidad del listado de tablas desde src/inheritance/table-list.js
   */
  extends: TableList,

  /**
   * @override
   */
  props: {
    id: {
      type: String,
      required: false
    }
  },

  /**
   * @override
   */
  data() {
    return {
      endLoad: false,
      items: [],
      metadata: {
        paging: {}
      },
      defaultColumns: [
        'id_object',
        'created_on',
        'account_type',
        'investor_class',
        'interveners',
        'signature_type',
        'source',
        'distributor',
        'subdistributor',
        'status',
        'external_code',
        'saldo_participaciones',
        'valoracion_inversion',
        'total_purchase_amount',
        'rentability',
        'first_subscription_date',
        'last_subscription_date',
        'has_active_periodic_subscription'
        // 'account_issues_count'
      ],
      defaultModificationsMonitorColumns: ['id_object', 'account_type', 'interveners', 'has_draft_data', 'has_pending_bank_account_doc'],
      listSearching: false,
      downloadingDocuments: [],
      loading: false
    };
  },
  methods: {
    rowCanBeValidated(row) {
      const isRegistered = row.status && row.status.includes('REGISTERED');
      const isNotRegisteredPostal = row.status && row.status !== 'REGISTERED_POSTAL';
      const isSigned = row.status === 'SIGNED';
      return (
        (row.can_be_validated && ((isRegistered && isNotRegisteredPostal) || isSigned)) ||
        (row.has_docs_been_downloaded && (isRegistered || isSigned))
      );
    },
    /**
     * Obtenemos la lista de cuentas desde el servicio
     * @param {String} sort Orden asc/desc
     * @param {Object} cfg Configuración de filtros
     */
    loadItems(sort = this.orderby, cfg = {}) {
      if (this.filters && Object.keys(this.filters).length) {
        cfg.params = {
          $filter: JSON.stringify(this.filters)
        };
      }

      const payload = {
        section: 'accounts',
        cfg
      };
      if (sort && sort !== 'false') {
        payload.sort = sort;
      }

      this.listSearching = true;
      this.loadData(payload)
        .then(res => {
          this.metadata = res.metadata;
          this.items = this.mapSelfName(res.data.accounts, ['id_object']);
          this.getColumns();
          this.filterColums();
          if (this.$route.query['modifications-monitor']) {
            this.columns = this.columns.filter(col => !['uuid', 'status'].includes(col.field));
            this.items = this.items.filter( item => item.has_draft_data === true || item.has_pending_bank_account_doc === true )
          }
          this.calculateColumnsWith(this.columns);
        })
        .catch(err => this.$toast.error(`Error Account List ${err.name}`, `${err.message}`))
        .finally(() => {
          this.endLoad = true;
          this.listSearching = false;
          this.$nextTick(() => {
            if (!this.tableHasScroll()) {
              this.infiniteScroll();
            }
          });
        });
    },

    /**
     * Ordenamos la tabla por un campo específico
     * Si el campo a ordenar es el patrimonio utilizamos una función que ordena las cuentas por patrimonio desde el front
     * En otro caso cargamos de nuevo los items utilizando los nuevos parametros de ordenación
     * @param {String} field Orden de la tabla
     */
    sort(field) {
      this.orderby = field;
      let cfg = {};
      if (this.filters && Object.keys(this.filters).length) {
        cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
      }
      this.loadItems(field, cfg);
      if (field && field !== 'false') {
        this.saveFilterInLocalstore(field, 'ob_acco');
      } else {
        this.removeFromLocalstore('ob_acco');
      }
    },

    /**
     * FILTRO DE RESULTADOS
     * Aplicamos los filtros seleccionados. Guardamos en localStore una variable con los filtros aplicados,
     * para que cuando el usuario cambie de sección y vuelva de nuevo a este listado, se carguen
     * los resultados que había filtrado.
     * @param {Array} filters Filtros para aplicar
     */
    filter(filters) {
      if (!this.id) {
        this.saveFilterInLocalstore(filters, 'filt_acco');
      }
      if (filters.length >= 1) {
        this.tbFilters = filters;
        this.applyFilters(filters);
        const cfg = {
          params: {
            $filter: JSON.stringify(this.filters)
          }
        };
        this.loadItems(this.orderby, cfg);
      } else {
        delete this.filters;
        this.loadItems();
      }
    },

    /**
     * SCROLL INFINITO
     * Método que se ejecuta cuanto el usuario ha hecho scroll y ha llegado al final de la tabla.
     * Se llama al método heredado 'pagination' y devuelve un array de resultados, los cuales
     * se 'mezclan' con los resultados que tenía la tabla.
     */
    infiniteScroll() {
      if (this.listSearching) {
        return;
      }
      const payload = {
        section: 'accounts',
        href: this.metadata.paging._links._next.href
      };
      if (this.$route.query['modifications-monitor']) {
        payload.href += `&modifications-monitor=${this.$route.query['modifications-monitor']}`;
      }
      if (payload.href && !this.isLoading) {
        this.pagination(payload)
          .then(res => {
            this.metadata = res.metadata;
            this.items = [...this.items, ...this.loadDataInTable(res.data.accounts, ['id_object'])];
          })
          .catch(err => this.$toast.error(`Error Account List infiniteScroll ${err.name}`, `${err.message}`));
      }
    },
    /**
     * @override
     */
    colsChange(cols) {
      this.columns = cols;
      this.saveFilterInLocalstore(cols, 'col_acco');
    },
    /**
     * Añade los filtros obtenidos de localStorage a la petición inicial
     * @param {Object} tbFilters filtros guardados en storage
     */
    addFiltersToRequest(tbFilters) {
      // Se añaden los filtros a la petición si están en el storage
      this.filters = [];
      tbFilters.forEach(filtro => {
        const condition = filtro.condition;
        this.filters.push({
          field: filtro.field,
          condition,
          conditionValue: filtro.conditionValue,
          orFilter: !!filtro.orFilter
        });
      });
      this.applyFilters(this.filters);
    },

    doSearch(val) {
      this.search = val;
      this.saveFilterInLocalstore(val, 'search_acco');
      this.loadItems();
    },

    validateAccount(account) {
      this.loading = true
      this.$accountsService
        .changeAccountStatus(account.uuid, { status: 'VALIDADO' })
        .then(() => {
          this.$toast.success(`Ok`, `${account._self_name} validado correctamente`);
          this.loadItems();
        })
        .catch(() => {
          this.$toast.error(`Error`, `Error al validar a ${account._self_name}`);
        })
        .finally(() => this.loading = false)
    },
    async sendAccountToRD(account) {
      if (account.status === 'VALIDADO') {
        try {
          await this.$accountsService.changeAccountStatus(account.uuid, {
            status: 'ENVIADO',
            sendToRD: true
          });
          this.$toast.success('OK', 'Enviado a RD correctamente');
          this.loadItems();
        } catch (err) {
          this.$toast.error(`Error ${err.name}`, `${err.message}`);
        }
      }
    },
    canRowDisplayContextMenu(row) {
      return (
        row.can_be_validated ||
        row.status === 'VALIDADO' ||
        (this.$refs.table && this.$refs.table.isAllowedToExecuteBatchDownloads)
      );
    },
    filterColums() {
      this.columns = this.columns.filter(col => {
        return ![ 
          'uuid', 
          'uuid_distributor', 
          'uuid_intervener_tax_address', 
          'uuid_owner',
          'uuid_subdistributor',
          'can_be_validated',
          'can_be_sent_to_rd',
          'class',
          'investor_class',
          'is_withholding_tax_exempt',
          'is_transfers_blocked',
          'is_deleted',
          'deleted_on',
          '_links',
          'mailing_type',
          'source'
        ].includes(col.field);
      });
    },
    handleLoadView(view) {
      this.filters = null;
      this.tbFilters = [];
      this.orderby = '';
      this.removeFromLocalstore('filt_acco');
      this.removeFromLocalstore('ob_acco');
      this.removeFromLocalstore('col_acco');
      this.removeFromLocalstore('search_acco');
      this.loadView(view);
    }
  },
  /**
   * @override
   */
  beforeMount() {
    this.section = 'accounts';
    this.loadSectionViews();
  },

  /**
   * Configuración inicial del componente
   * 1. Asignamos las columnas por defecto del listado de la tabla
   * 2. Obtenemos los filtros que el usuario pueda haber aplicado con anterioridad
   * 3. Obtenemos la información de la tabla
   */
  mounted() {
    this.$root.$off('downloading');
    this.$root.$on('downloading', uuids => {
      this.downloadingDocuments = uuids;
    });
    this.$root.$off('updateItems');
    this.$root.$on('updateItems', () => {
      this.loadItems();
      this.downloadingDocuments = [];
    });

    if (this.id) {
      const filter = {
        field: 'uuid_intervener',
        condition: 'in',
        conditionValue: this.id
      };
      this.tbFilters = [filter];
      this.addFiltersToRequest(this.tbFilters);
      this.loadItems();
    } else {
      this.tbFilters = this.loadFilterInLocalstore('filt_acco');
      this.orderby = this.loadFilterInLocalstore('ob_acco');
      this.search = this.loadFilterInLocalstore('search_acco');

      this.addFiltersToRequest(this.tbFilters);

      const storedView = JSON.parse(localStorage.getItem(`table_view_selected_${this.$route.name}`));
      if (storedView) {
        this.loadView(storedView);
      } else if (
        this.orderby &&
        this.orderby !== 'false' &&
        this.orderby.length > 0 &&
        this.orderby !== this.$route.query['sorts-by']
      ) {
        const query = { 'sorts-by': this.orderby };
        this.$router
          .replace({
            path: this.$route.path,
            query
          })
          .then(() => {
            this.sort(this.orderby);
          });
      } else {
        this.loadItems();
      }
      this.columns = this.loadFilterInLocalstore('col_acco');
    }
  },
  beforeDestroy() {
    this.$root.$off('updateItems');
    this.$root.$off('downloading');
  }
};
